module.exports = __webpack_public_path__ + "static/media/logo-carire.ed83b6d3.png";